export interface TrainingMaterialRecord {
  id: string;
  name: string;
  type: 'PDF' | 'URL' | 'TSX';
  sharePeriod: { start: string; end: string };
  uploadDate: string;
  status: 'sharing' | 'scheduled';
  order: number;
  tsxPath?: string;
  url?: string;
  fileUrl?: string;
}

export const AI_EDUTECH_TRAININGS: TrainingMaterialRecord[] = [
  {
    id: 'deaGwamg-ai-edutech',
    name: '대광고등학교 AI 에듀테크 연수',
    type: 'TSX',
    tsxPath: '/teacher-training/AIEdutech/DeaGwamgAIEdutechTraining',
    sharePeriod: { start: '2025.10.01', end: '2025.12.31' },
    uploadDate: '2025.10.01',
    status: 'sharing',
    order: 1,
  },
  {
    id: 'setivibe-coding',
    name: '세티바이브 코딩 연수',
    type: 'TSX',
    tsxPath: '/teacher-training/AIEdutech/SetiVibeCodingTraining',
    sharePeriod: { start: '2025.10.01', end: '2025.12.31' },
    uploadDate: '2025.10.01',
    status: 'sharing',
    order: 2,
  },
  {
    id: 'robot-highschool-vibe-coding',
    name: '로봇고등학교 찾아가는 학교 연수: Cursor, Firebase를 활용한 웹앱 - IoT 바이브코딩',
    type: 'TSX',
    tsxPath: '/teacher-training/AIEdutech/RobotHighSchoolVibeCodingTraining',
    sharePeriod: { start: '2025.12.04', end: '2025.12.31' },
    uploadDate: '2025.12.04',
    status: 'sharing',
    order: 3,
  },
  {
    id: 'sunrin-ai-training',
    name: '선린중학교 AI 연수',
    type: 'TSX',
    tsxPath: '/teacher-training/AIEdutech/SunrinAITraining',
    sharePeriod: { start: '2025.01.01', end: '2025.12.31' },
    uploadDate: '2025.01.01',
    status: 'sharing',
    order: 4,
  },
];
